export const frontmatter = {
    "draft": true,
    "title": "Python SDK",
    "description": "Official OnnIA library to interact with channels, execute workflows, and integrate intelligent agents from Python applications.",
    "sidebar_label": "Python",
    "sidebar_group": "reference",
    "sidebar_order": 2
}

export const toc = [
    {
        "depth": 2,
        "id": "installation",
        "value": "Installation"
    },
    {
        "depth": 2,
        "id": "initialization",
        "value": "Initialization"
    },
    {
        "depth": 2,
        "id": "usage-examples",
        "value": "Usage examples"
    },
    {
        "depth": 3,
        "id": "send-messages",
        "value": "Send messages"
    },
    {
        "depth": 3,
        "id": "start-a-workflow",
        "value": "Start a Workflow"
    }
]